__turbopack_context__.v({
  "card": "MobileMotto-module__dPh6va__card",
  "cardImg": "MobileMotto-module__dPh6va__cardImg",
  "content": "MobileMotto-module__dPh6va__content",
  "group": "MobileMotto-module__dPh6va__group",
  "headings": "MobileMotto-module__dPh6va__headings",
  "headingsMain": "MobileMotto-module__dPh6va__headingsMain",
  "headingsSubtitle": "MobileMotto-module__dPh6va__headingsSubtitle",
  "scene": "MobileMotto-module__dPh6va__scene",
});
